'use strict';

var floor = require('./floor');

var msPerDay = require('../helpers/timeConstants').msPerDay;

// https://262.ecma-international.org/5.1/#sec-15.9.1.2

module.exports = function Day(t) {
	return floor(t / msPerDay);
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2016/Day.js
// module id = 234
// module chunks = 0